import {
	attributes,
	pushTrackingData,
	getTrackingData,
	isExternalLink,
} from './utils';

const {
	GTM_CLICK_IGNORE_ATTRIBUTE,
	GTM_CLICK_ATTRIBUTE,
	GTM_PUSH_ATTRIBUTE,
} = attributes;


const TRACKING_ELEMENT_SELECTOR = [
	`[${GTM_CLICK_ATTRIBUTE}]`,
	`a:not([${GTM_CLICK_IGNORE_ATTRIBUTE}])`,
].join(',');


const getTrackableElement = el => el.closest(TRACKING_ELEMENT_SELECTOR);

// Always return true since it can be a click on a link
const onElementClick = (e) => {
	const { target } = e;

	const el = getTrackableElement(target);

	if (!el) {
		return true;
	}

	if (el.hasAttribute(GTM_PUSH_ATTRIBUTE)) {
		pushTrackingData(getTrackingData(el));

		return true;
	}

	if (isExternalLink(el)) {
		const link = el.getAttribute('href');

		const event = {
			event: 'clickout_general',
			events: {
				category: 'Clickout General',
				action: link,
			},
		};

		pushTrackingData(event);

		return true;
	}

	return true;
};

const startClickTracking = (root = document.body) => root.addEventListener('click', e => onElementClick(e));

export default startClickTracking;
